// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d521569","453":"0098adef","455":"211d5ead"}[chunkId] + ".chunk.js";
};